module.exports = __webpack_public_path__ + "static/media/Roboto.c613ca81.ttf";